import React from "react";
import closebtn from "../../assets/images/close.svg";
import crossarrow from "../../assets/images/crossarrow.svg";
import { Link } from "react-router-dom";

function PasswordLocker({
  handleshowPopup,
  accordionPopupTitle,
  accordionBody,
  accordionBody2,
  accordionsemititle,
  accordionsemicontent,
  accordionsemititle1,
  accordionsemicontent1,
  accordionsemititle2,
  accordionsemicontent2,
  accordionsemititle3,
  accordionsemicontent3,
  accordionsemititle4,
  accordionsemicontent4,
  accordionsemititle5,
  accordionsemicontent5,
  accordionsemititle6,
  accordionsemicontent6,
  smallPara,
  listitems,
  bigPara
}) {
  return (
    <>
      <div className="schedular-popup password-locker-popup">
        <div className="popup-title">
          <h2>{accordionPopupTitle}</h2>
          <img
            src={closebtn}
            alt="close"
            id="password-locker"
            className="cursor-pointer"
            onClick={(e) => {
              handleshowPopup(e);
            }}
          />
        </div>
        <div className="popup-body">
          <p>{accordionBody ? accordionBody : ""}</p>
          <p>{accordionBody2 ? accordionBody2 : ""}</p>
          <h6>{accordionsemititle ? accordionsemititle : ""}</h6>
          <p>{accordionsemicontent ? accordionsemicontent : ""}</p>
          <h6>{accordionsemititle1 ? accordionsemititle1 : ""}</h6>
          <p>{accordionsemicontent1 ? accordionsemicontent1 : ""}</p>
          <h6>{accordionsemititle2 ? accordionsemititle2 : ""}</h6>
          <p>{accordionsemicontent2 ? accordionsemicontent2 : ""}</p>
          <h6>{accordionsemititle3 ? accordionsemititle3 : ""}</h6>
          <p>{accordionsemicontent3 ? accordionsemicontent3 : ""}</p>
          <h6>{accordionsemititle4 ? accordionsemititle4 : ""}</h6>
          <p>{accordionsemicontent4 ? accordionsemicontent4 : ""}</p>
          <h6>{accordionsemititle5 ? accordionsemititle5 : ""}</h6>
          <p>{accordionsemicontent5 ? accordionsemicontent5 : ""}</p>
          <h6>{accordionsemititle6 ? accordionsemititle6 : ""}</h6>
          <p>{accordionsemicontent6 ? accordionsemicontent6 : ""}</p>
          <p>{smallPara ? smallPara : ""}</p>
          <ul>
            {listitems
              ? listitems.map((item, index) => <li key={index}>{item}</li>)
              : ""}
          </ul>
          <p>{bigPara ? bigPara : ""}</p>

          <Link to="#" className="learn-more-crossarrow">
            <span>Learn More</span>
            <div className="crossarrow">
              <img
                src={crossarrow}
                alt="crossarrow"
                onClick={(e) => {
                  handleshowPopup(e);
                }}
              />
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default PasswordLocker;
